import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';
import { ResidentSelectRestaurantComponent } from './resident-select-restaurant/resident-select-restaurant.component';

@Component({
	selector: 'app-resident-customer-list',
	templateUrl: './resident-customer-list.component.html',
	styleUrls: ['./resident-customer-list.component.css'],
})
export class ResidentCustomerListComponent extends ListComponent {
	protected itemsBeforeDataLoad = 1;
	protected apiUrl = 'resident/residentCustomer';
	filters;
	parameters = {
		destinations: [],
		products: [],
		restaurantList: [],
	};

	tableRows = [
		{ id: 'name', name: 'Destynacja' },
		{ id: 'businessCaseNumber', name: 'Numer rezerwacji' },
		{ id: 'person', name: 'Imie Nazwisko' },
		{ id: 'phone', name: 'Numer telefonu' },
		{ id: 'offerName', name: 'Oferta' },
		{ id: 'productName', name: 'Zakwaterowanie' },
		{ id: 'roomNumber', name: 'Pokój' },
		{ id: 'dateFrom', name: 'Zakwaterowanie od' },
		{ id: 'dateTo', name: 'Zakwaterowanie do' },
		{ id: 'residentRestaurant', name: 'Restauracja' },
	];

	protected loadBefore() {
		this.api.get('/bag/bagLocations/', (result, error) => {
			this.parameters.destinations = result.data.filter((obj) => ['11', '12', '143', '144'].includes(obj.id));
		});
		this.api.get('/resident/residentRestaurant/', (result, error) => {
			this.parameters.restaurantList = result.data;
		});
		this.bag.get('/product/?limit=9999', (result, error) => {
			this.parameters.products = result?.results.map((obj) => ({
				...obj,
				id: obj.id.toString(),
			}));
		});
	}

	modalOpen() {
		new ResidentSelectRestaurantComponent(this.api, this.infobox).dialogOpen();
	}

	modalClosed() {
		this.loadData();
	}

	protected convertData(data) {
		data.forEach((obj) => {
			obj.person = obj.firstName + ' ' + obj.lastName;
		});
		return data;
	}
}
